var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import HeaderItem from "../accountcheck/components/HeaderItem.vue";
import PaymentService from '../../api/PaymentService';
import UpperPaymentService from '../../api/UpperPaymentService';
import { Loading } from 'element-ui';
import Detail from "../accountcheck/Detail.vue";
import GLOBAL_VUE from '../../globalVue';
import { auth } from "../../helper/authDecorator";
import { nameDict } from "../../constant/authCode";
import EAccountType from '../../enum/EAccountType';
var EConfirmStatus;
(function (EConfirmStatus) {
    EConfirmStatus[EConfirmStatus["confirmNo"] = 1] = "confirmNo";
    EConfirmStatus[EConfirmStatus["confirmYes"] = 2] = "confirmYes";
    EConfirmStatus[EConfirmStatus["canceled"] = 5] = "canceled";
})(EConfirmStatus || (EConfirmStatus = {}));
var PaymentOrderDetail = (function (_super) {
    __extends(PaymentOrderDetail, _super);
    function PaymentOrderDetail() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.data = [];
        _this.tableHeight = 350;
        _this.rowId = null;
        _this.order = {
            account_date: [],
        };
        _this.swiperShow = false;
        _this.imgs = [];
        _this.detailDialogTemplate = '';
        _this.eType = EAccountType;
        _this.confirmStatus = EConfirmStatus;
        _this.payment_type_list = [];
        _this.selection = [];
        _this.PaymentDatePickerOptions = {
            disabledDate: function (time) {
                return false;
            }
        };
        return _this;
    }
    PaymentOrderDetail.prototype.mounted = function () {
        this.service = PaymentService.getInstance();
        this.upperservice = UpperPaymentService.getInstance();
        this.paymentTypeList();
        this.getPaymentDetail();
    };
    PaymentOrderDetail.prototype.paymentTypeList = function () {
        var _this = this;
        this.upperservice.getPaymentType().then(function (res) {
            if (res.data.success) {
                _this.payment_type_list = res.data.data;
            }
            else {
                _this.$message.error(res.data.msg);
            }
            ;
        }, function (err) {
            _this.$message.error(err.message);
        }).catch(function (err) {
            _this.$message.error(err.message);
        });
    };
    PaymentOrderDetail.prototype.getPaymentDetail = function (pager) {
        var _this = this;
        if (pager === void 0) { pager = { page: 1, start: 0, limit: 20 }; }
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service.getPaymentDetail(Object.assign({ order_id: this.rowId }, pager)).then(function (res) {
            if (res.data.success) {
                var data = res.data.data;
                _this.data = data.order_list;
                _this.order = data;
                console.log('this.order', _this.order);
                _this.tableHeight = document.documentElement.clientHeight - 350 + (_this.order.order_status == _this.confirmStatus.confirmNo ? 40 : 0);
                setTimeout(function () {
                    _this.$refs.table.toggleAllSelection(true);
                }, 0);
            }
            else {
                _this.$message.error(res.data.msg);
            }
            ;
            loadingInstance.close();
        }, function (err) {
            _this.$message.error(err.message);
            loadingInstance.close();
        }).catch(function (err) {
            _this.$message.error(err.message);
            loadingInstance.close();
        });
    };
    PaymentOrderDetail.prototype.pageChange = function (pager) {
        this.getPaymentDetail(pager);
    };
    PaymentOrderDetail.prototype.selectionChange = function (selection) {
        this.selection = selection;
    };
    PaymentOrderDetail.prototype.toLookImg = function (row) {
        this.$refs.carousel.setActiveItem(0);
        this.swiperShow = true;
        this.imgs = row.order_document;
    };
    PaymentOrderDetail.prototype.confirm = function () {
        var _this = this;
        this.$confirm('确认后将不可修改，是否继续？', '提示', {
            customClass: 'confirm'
        }).then(function (res) {
            if (res) {
                var loadingInstance_1 = Loading.service({ fullscreen: true });
                _this.service.confirmBill({ order_id: _this.order.order_id }).then(function (res) {
                    loadingInstance_1.close();
                    if (res.data.code == 76) {
                        _this.$message.error(res.data.msg);
                        _this.getPaymentDetail();
                    }
                    else {
                        _this.$message.success(res.data.msg);
                        if (_this.opener && _this.opener.getPaymentList) {
                            _this.opener.getPaymentList();
                        }
                        GLOBAL_VUE.$emit("closeTab", _this);
                        window._czc.push(["_trackEvent", '付款单列表', '确认付款单']);
                    }
                }).catch(function (err) {
                    loadingInstance_1.close();
                    _this.$message.error(err.message || err.msg);
                });
            }
        }).catch(function () { });
    };
    PaymentOrderDetail.prototype.save = function () {
        var _this = this;
        if (!this.selection || !this.selection.length) {
            this.$message.warning("请选择详情单据");
            return;
        }
        if (!this.order.payment_deadline) {
            this.$message.warning("请选择付款时间");
            return;
        }
        var params = {
            order_id: this.order.order_id,
            statement_order_ids: this.selection.map(function (item) { return item.order_id; }).join(","),
            order_money: this.order.order_money,
            payment_deadline: this.order.payment_deadline,
            payment_type: this.order.payment_type,
            is_tax_ticket: this.order.is_tax_ticket,
            order_icomment: this.order.order_icomment,
        };
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service.saveBill(params).then(function (res) {
            loadingInstance.close();
            _this.$message.success(res.data.msg);
            if (_this.opener && _this.opener.getPaymentList) {
                _this.opener.getPaymentList();
            }
            ;
            GLOBAL_VUE.$emit("closeTab", _this);
            window._czc.push(["_trackEvent", '付款单列表', '确认付款单']);
        }).catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.message || err.msg);
        });
    };
    PaymentOrderDetail.prototype.toAccountDetail = function (row) {
        GLOBAL_VUE.$emit("addTab", {
            component: Detail,
            title: '对账单详情',
            showExist: true,
            name: 'detail-account-check-' + row.order_id,
            cprops: {
                rowId: row.order_id
            }
        });
    };
    PaymentOrderDetail = __decorate([
        auth(nameDict["客户付款单"]),
        Component({
            components: {
                HeaderItem: HeaderItem
            }
        })
    ], PaymentOrderDetail);
    return PaymentOrderDetail;
}(Vue));
export default PaymentOrderDetail;
